import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';

/** Role gate (any of). Members without the role land back on My rides. */
export function RequireRole({ roles, children }: { roles: string[]; children: ReactNode }) {
  const { hasAnyRole } = useEnrichedAuth();
  if (!hasAnyRole(roles)) return <Navigate to="/home" replace />;
  return <>{children}</>;
}
